import { Component } from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
    selector: 'app-public-navigation',
    imports: [
        RouterLinkActive,
        RouterLink
    ],
    templateUrl: './public-navigation.component.html',
    styleUrl: './public-navigation.component.scss'
})
export class PublicNavigationComponent {

}
